import { createSlice } from '@reduxjs/toolkit';
import { Wallet } from '../../generated/mlmbox/types/wallet';

export interface IWalletState extends Wallet {
    loading: boolean;
}

const initialState: { value: IWalletState } = {
    value: {
        loading: true,
        processings: [
            {
                assets: [
                    {
                        assetId: 1,
                        settingsDepositEnabled: false,
                        settingsWithdrawalEnabled: false,
                        settingsWithdrawalFeeBase: '0',
                        settingsWithdrawalFeePercent: '0',
                        settingsWithdrawalOperationValueMax: '',
                        settingsWithdrawalOperationValueMin: '',
                    },
                ],
                processingId: 0,
                processingName: '',
            },
        ],
        assets: [
            {
                assetId: 1,
                assetBalance: '0',
                transactions: [],
                settingsTransferEnabled: false,
                settingsTransferLimitMin: '',
            },
            {
                assetId: 2,
                assetBalance: '0',
                transactions: [],
                settingsTransferEnabled: false,
                settingsTransferLimitMin: '',
            },
        ],
    },
};

export const walletSlice = createSlice({
    name: 'walelt',
    initialState,
    reducers: {
        resetBalance: (state, { payload }) => {
            state.value.assets = payload;
        },
        resetBalanceById: (state, { payload }: { payload: { assetId: number; balance: string } }) => {
            state.value.assets[payload.assetId - 1].assetBalance = payload.balance;
        },
        setLoadingWallet: (state, { payload }: { payload: { loading: boolean } }) => {
            state.value.loading = payload.loading;
        },
    },
});

export const { resetBalance, resetBalanceById, setLoadingWallet } = walletSlice.actions;

export default walletSlice.reducer;
